import { Expose } from "class-transformer";

export class EventPlanModel {
  constructor() {
    this.planId = null;
    this.routePlanId = null;
    this.customerPlanId = null;
  }

  @Expose({ name: "planId" })
  planId: number | null;

  @Expose({ name: "routePlanId" })
  routePlanId: number | null;

  @Expose({ name: "customerPlanId" })
  customerPlanId: number | null;
}
